import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { AbstractControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms'
import { CoreService, NotificationService } from '../../services'
import { OAuthSession } from 'depoto-core/src/models'
import { Events } from 'depoto-core/src/utils/EventsUtil'
import { TranslateService } from '@ngx-translate/core'
import { AVAILABLE_LANGUAGES } from '../../configs'

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  client_type_options = [
    {
      id: 'prod-hs',
      name: 'produkce',
    },
    {
      id: 'stage-hs',
      name: 'stage',
    },
    {
      id: 'dev',
      name: 'development',
    },
    {
      id: 'custom',
      name: 'vlastní',
    },
  ]
  loginForm = new UntypedFormGroup({
    email: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.email]),
    password: new UntypedFormControl({ value: '', disabled: false }, [Validators.required]),
    clientType: new UntypedFormControl({ value: this.client_type_options[0].id, disabled: false }, [
      Validators.required,
    ]),
    customUrl: new UntypedFormControl({
      value: 'http://localhost/tomatom/depoto-server/web/app_dev.php/',
      disabled: false,
    }),
    rememberMe: new UntypedFormControl({ value: true, disabled: false }),
  })
  loading = false
  isShowingAdvanced = false
  showPassword = false
  submitted = false
  year = `${new Date().getFullYear()}`
  public readonly availableLanguages = AVAILABLE_LANGUAGES
  public selectedLanguage: string

  constructor(
    private router: Router,
    private core: CoreService,
    private notificationService: NotificationService,
    private translateService: TranslateService,
  ) {
    this.selectedLanguage = this.getAllowedLang(this.translateService.getBrowserLang())
    this.translateService.use(this.selectedLanguage)
  }

  ngOnInit() {
    if (window.location.href.includes('stage') || window.location.href.includes('local')) {
      this.loginForm.controls.clientType.setValue('stage-hs')
    }
    this.reloadTokens()
  }

  async reloadTokens(): Promise<any> {
    this.loading = true
    if (this.core.services.oauth.isAuthenticated()) {
      if (
        !(
          (!this.core.services.oauth.session.isRememberMe && (await this.core.services.oauth.getAccessToken())) ||
          (this.core.services.oauth.session.isRememberMe && (await this.core.services.oauth.getRefreshToken()))
        )
      ) {
        return new Promise<void>(r => r())
      }
      if (!this.core.services.vat.defaultVat) {
        this.core.services.vat.getDefaultVat()
      }
      setTimeout(() => {
        this.loading = false
        Events.dispatch('init:loading')
      }, 200)
    }
    setTimeout(() => (this.loading = false), 250)
  }

  async login() {
    this.submitted = true
    if (this.loginForm.invalid) {
      return
    }
    const session = new OAuthSession({
      email: this.loginForm.value.email,
      password: this.loginForm.value.password,
      clientType: this.loginForm.value.clientType,
      isRememberMe: this.loginForm.value.rememberMe,
      clientCustomUri: this.loginForm.value.customUrl,
      clientId: '28_1somkcpdjp8kcgw0g8s0wkogssc40ok8so0cgosg0o0w000o8g',
      clientSecret: '5mfy9qmt4c0sgw4080gggswso00ks08sow84skcck0o4wkw8sk',
    })
    this.loading = true
    this.core.services.oauth
      .getToken(session)
      .then(async res => {
        if (res) {
          await this.core.services.user.setCurrentUser(session.email)
          if (!this.core.services.vat.defaultVat) {
            this.core.services.vat.getDefaultVat()
          }
          setTimeout(() => {
            this.core.loadLists()
            this.loading = false
          }, 250)
        } else {
          this.notificationService.error(this.translateService.instant('login.error'))
          this.loading = false
        }
      })
      .catch(err => {
        this.notificationService.error(this.translateService.instant('login.error'))
        this.loading = false
      })
  }

  setCustomServerUrl(): void {
    this.core.services.storage.set(this.core.services.storage.keys.auth.customServerUrl, this.loginForm.value.customUrl)
  }

  toggleShowPassword(): void {
    this.showPassword = !this.showPassword
  }

  get formControls(): { [key: string]: AbstractControl } {
    return this.loginForm.controls
  }

  setLanguage($event: any) {
    this.selectedLanguage = $event
    this.translateService.use($event)
  }

  getAllowedLang(lang: 'cs' | 'pl' | 'en' | string): 'cs' | 'pl' | 'en' {
    if (lang === 'cs' || lang === 'pl' || lang === 'en') {
      return lang
    } else if (lang === 'sk') {
      return 'cs'
    } else {
      return 'en'
    }
  }
}
